// @ts-nocheck
import { name2num, num2name, } from "./(GetResultResponse)/ProcessStatus";
import { tsValueToJsonValueFns, jsonValueToTsValueFns, } from "../../../../../runtime/json/scalar";
import { WireType, } from "../../../../../runtime/wire/index";
import { default as serialize, } from "../../../../../runtime/wire/serialize";
import { default as Long, } from "../../../../../runtime/Long";
import { tsValueToWireValueFns, wireValueToTsValueFns, } from "../../../../../runtime/wire/scalar";
import { default as deserialize, } from "../../../../../runtime/wire/deserialize";
export function getDefaultValue() {
    return {
        status: "PROCESS_STATUS_UNSPECIFIED",
        outputXlsxLink: "",
        outputLogLink: "",
    };
}
export function createValue(partialValue) {
    return {
        ...getDefaultValue(),
        ...partialValue,
    };
}
export function encodeJson(value) {
    const result = {};
    if (value.status !== undefined)
        result.status = tsValueToJsonValueFns.enum(value.status);
    if (value.outputXlsxLink !== undefined)
        result.outputXlsxLink = tsValueToJsonValueFns.string(value.outputXlsxLink);
    if (value.outputLogLink !== undefined)
        result.outputLogLink = tsValueToJsonValueFns.string(value.outputLogLink);
    return result;
}
export function decodeJson(value) {
    const result = getDefaultValue();
    if (value.status !== undefined)
        result.status = jsonValueToTsValueFns.enum(value.status);
    if (value.outputXlsxLink !== undefined)
        result.outputXlsxLink = jsonValueToTsValueFns.string(value.outputXlsxLink);
    if (value.outputLogLink !== undefined)
        result.outputLogLink = jsonValueToTsValueFns.string(value.outputLogLink);
    return result;
}
export function encodeBinary(value) {
    const result = [];
    if (value.status !== undefined) {
        const tsValue = value.status;
        result.push([1, { type: WireType.Varint, value: new Long(name2num[tsValue]) }]);
    }
    if (value.outputXlsxLink !== undefined) {
        const tsValue = value.outputXlsxLink;
        result.push([2, tsValueToWireValueFns.string(tsValue)]);
    }
    if (value.outputLogLink !== undefined) {
        const tsValue = value.outputLogLink;
        result.push([3, tsValueToWireValueFns.string(tsValue)]);
    }
    return serialize(result);
}
export function decodeBinary(binary) {
    const result = getDefaultValue();
    const wireMessage = deserialize(binary);
    const wireFields = new Map(wireMessage);
    field: {
        const wireValue = wireFields.get(1);
        if (wireValue === undefined)
            break field;
        const value = wireValue.type === WireType.Varint ? num2name[wireValue.value[0]] : undefined;
        if (value === undefined)
            break field;
        result.status = value;
    }
    field: {
        const wireValue = wireFields.get(2);
        if (wireValue === undefined)
            break field;
        const value = wireValueToTsValueFns.string(wireValue);
        if (value === undefined)
            break field;
        result.outputXlsxLink = value;
    }
    field: {
        const wireValue = wireFields.get(3);
        if (wireValue === undefined)
            break field;
        const value = wireValueToTsValueFns.string(wireValue);
        if (value === undefined)
            break field;
        result.outputLogLink = value;
    }
    return result;
}
